/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }

  getWhatsappWebSession(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_web`);
  }

  startWhatsappWebSession(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_web/start`);
  }

  logoutWhatsappWebSession(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_web/logout`);
  }

  refreshWhatsappWebSession(inboxId) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_web/refresh`);
  }

  getChatExclusions(inboxId) {
    return axios.get(`${this.url}/${inboxId}/chat_exclusions`);
  }

  getChatExclusionCandidates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/chat_exclusions/candidates`);
  }

  createChatExclusion(inboxId, chatExclusion) {
    return axios.post(`${this.url}/${inboxId}/chat_exclusions`, {
      chat_exclusion: chatExclusion,
    });
  }

  updateChatExclusion(inboxId, exclusionId, chatExclusion) {
    return axios.patch(
      `${this.url}/${inboxId}/chat_exclusions/${exclusionId}`,
      {
        chat_exclusion: chatExclusion,
      }
    );
  }

  deleteChatExclusion(inboxId, exclusionId) {
    return axios.delete(
      `${this.url}/${inboxId}/chat_exclusions/${exclusionId}`
    );
  }
}

export default new Inboxes();
